

import React from 'react';

export default function Footer() {
  return <div className='footer'>
      <p>2022 &copy; Laundry </p>

  </div>;
}
